import { FC } from 'react'
import BroadcastPageLayout from 'container/BroadcastPageLayout'

const SingleBroadcast: FC = () => {
	return <BroadcastPageLayout />
}

export default SingleBroadcast
